import * as React from 'react'
import { useRef } from 'react';
import { AutoCompleteInput } from 'uxp/components'
import './ContextDataAutoComplete.scss'

interface IContextDataAutoCompleteProps {
    value: string;
    onChange: (v: string) => void;
    contextData: any;
}
export const ContextDataAutoComplete: React.FunctionComponent<IContextDataAutoCompleteProps> = (props) => {

    let inputRef = useRef(null)

    let ctx = props.contextData || {};
    let keys = Object.keys(ctx);
    let items = React.useMemo(() => {
        let sitems = [];
        for (let key of keys) {
            if (!key || !ctx[key]) continue;
            let ckeys = Object.keys(ctx[key]);
            for (let ck of ckeys) {
                sitems.push({ type: key, item: ck });
            }
        }
        return sitems;
    }, [ctx]);
    function expression(i: any) {
        return `{$.${i.type}.${i.item}}`;
    }
    function renderSuggestions() {

        // let filteredItems = items.filter(x=>x.item.toLowerCase().indexOf(props.value.toLowerCase())>=0);
        return <div className='uxp_wd-ac'>
            {
                items.map((item, i) => {
                    return <div key={i} className='uxp_wd-ac__option'
                        onClick={() => {
                            // props.onChange(expression(item))
                            inputRef.current?.appendAtCursor(expression(item))
                        }}
                    >
                        <div className='uxp_wd-ac__type'>{item.type}</div>
                        <div className='uxp_wd-ac__value'>{item.item}</div>
                    </div>
                })
            }
        </div>
    }

    return <AutoCompleteInput
        value={props.value}
        onChange={props.onChange}
        autoFill={renderSuggestions}
        ref={inputRef}
        className="widget-designer-input"
    />;
};